import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../../../css/lockedBetRacing.css';
// helpers
import {getRacingMarketNameByCode} from '../../../helpers/marketHelpers';
import {getFormattedCurrency, getText, usingNonDecimalCurrency} from '../../../../../helpers/localization';
// components
import LockedBet from '../../../components/lockedBet';
import {PLACED, SETTLED, SETTLED_IN_HISTORY, VOIDED} from "../../../../../constants/identifiers";
import {PLACE, SHOW, TO_WIN} from '../constants/identifiers';
import {roundNumber} from "../../../../../helpers/mathFunctions";
import {BASE_VALUE} from "../../../../../constants/chips";
import {calculateEachWayValues} from "../../../../../helpers/eachWayBetHelpers";
import {getGameTitle} from "../../../../../helpers/eventHelpers";
import {getOddsFromOddsType} from "../../../../../helpers/oddsHelpers";
import {isEnabledMarket} from '../../../helpers/betHelpers';
import {isMarbleEuroEvent, isMarbleEvent} from "../helpers/racersHelper";
import {getGameByChannel} from '../../../helpers/gameHelpers';

const mapStateToProps = (state, ownProps) => {
    return {selectedOddsType: state.vpp.selectedOddsType, disabledMarkets: state.vpp.disabledMarkets, systemLanguage: state.vpp.systemLanguage};
};

class LockedBetRacing extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            selectedOddsType: storeData.vpp.selectedOddsType,
            disabledMarkets: storeData.vpp.disabledMarkets,
            systemLanguage: storeData.vpp.systemLanguage
        };

    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                selectedOddsType: storeData.vpp.selectedOddsType,
                disabledMarkets: storeData.vpp.disabledMarkets,
                systemLanguage: storeData.vpp.systemLanguage
            });
        }
    }

    _createEventDetails(bet) {

        let eventDetails = bet.EventDetails;
        let competitors = eventDetails.competitors;


        return competitors.map((competitor, index) => {
            let isEvenStyle = index % 2 === 0 ? style.even : '';

            let position = '';
            switch (index) {
                case 0:
                    position = getText('FIRST_ST', this.props.store) + getText('ST', this.props.store);
                    break;
                case 1:
                    position = getText('SECOND_ND', this.props.store) + getText('ND', this.props.store);
                    break;
                case 2:
                    position = getText('THIRD_RD', this.props.store) + getText('RD', this.props.store);
                    break;
                default:
                    break;
            }

            return (
                <div key={'eventDetailsCompetitor' + index}
                     className={`${style.eventDetailsCompetitor} ${isEvenStyle}`}>
                    <div className={style.eventDetailsCompetitorNumNameContainer}>
                        <div className={style.position}>{position}</div>
                        <div
                            className={style.eventDetailsCompetitorNum}>{isMarbleEvent(this.props.betSelection.Bets[0].EventType)
                            ? this._getMarbleRacerNames(bet, competitor.num, this.props.store) : competitor.num + '. '}</div>
                        <div className={style.eventDetailsCompetitorName}>{competitor.name}</div>
                    </div>
                    {this._displayOdds(bet.Channel, competitor.price, TO_WIN.name)}
                    {this._displayOdds(bet.Channel, competitor.place, PLACE.name)}
                    {this._displayOdds(bet.Channel, competitor.show, SHOW.name)}
                </div>
            )
        });
    }

    _displayOdds(channel, odd, market) {
        if (odd === undefined) {
            return '';
        } else if (isEnabledMarket(this.state, this.props.disabledMarkets, channel, market)) {
            return (<div
                className={style.eventDetailsCompetitorPrice}>{getOddsFromOddsType(odd, this.state.selectedOddsType)}</div>)
        }
    }

    render() {
        let betSelection = this.props.betSelection;
        let bet = betSelection.Bets[0];
        let voidStatus = bet.State === 'VOIDED';
        let eventName = getGameTitle(getText(bet.Title, this.props.store), bet.EventTime, this.props.store.getState().vpp.systemLanguage);

        let silks;
        // let silks = marketNum.split('-');

        let odd = bet.Market.Price;

        let marketInfo = bet.OpaqueData === undefined ? null : JSON.parse(bet.OpaqueData);
        let racersNamesList = marketInfo === null ? '' : marketInfo.racersInfo.map((info, index) => {

            return isMarbleEvent(bet.EventType) ? this._getMarbleRacerNames(bet, info.num, this.props.store) : (info.num + '. ' + info.racer);
        });

        let eventDetails;
        let potentialReturns;
        let betType;
        let stake;
        let prize;

        let channel = betSelection.Bets[0].Channel;
        let toWinHeader;
        let placeHeader;
        let showHeader;
        if (bet !== undefined && bet.EventDetails !== undefined && bet.EventDetails.competitors != undefined) {
            if (isEnabledMarket(this.state, this.props.disabledMarkets, channel, TO_WIN.name) && bet.EventDetails.competitors[0].price != undefined) {
                toWinHeader = (<div className={style.winPlaceShow}> {getText('WIN', this.props.store)}</div>);
            }
            if (isEnabledMarket(this.state, this.props.disabledMarkets, channel, PLACE.name) && bet.EventDetails.competitors[0].place != undefined) {
                placeHeader = (<div className={style.winPlaceShow}> {getText('PLACE', this.props.store)}</div>);
            }

            if (isEnabledMarket(this.state, this.props.disabledMarkets, channel, SHOW.name) && bet.EventDetails.competitors[0].show != undefined) {
                showHeader = (<div className={style.winPlaceShow}> {getText('SHOW', this.props.store)}</div>);
            }
        }

        if (this.props.betsType !== PLACED && this.props.betsType !== VOIDED && !voidStatus) {
            eventDetails = (
                <div className={style.eventDetailsWrapper}>
                    <div className={style.eventDetails}>
                        <div className={style.winPlaceShowContainer}>
                            {toWinHeader}
                            {placeHeader}
                            {showHeader}
                        </div>
                        {this._createEventDetails(bet)}</div>
                </div>
            );
        }

        //if it's eachWay
        if (this.props.betSelection.Bets[0].ExternalRefId !== undefined) {

            betType = getText('EW', this.props.store);
            if (usingNonDecimalCurrency(this.props.store.getState().vpp.systemCurrency)) {
                stake = this.props.betSelection.Bets[0].Stake / 2;
            } else {
                stake = roundNumber((this.props.betSelection.Bets[0].Stake / 2) / BASE_VALUE, 2);
            }
            let marketInfo = this.props.betSelection.Bets[0].OpaqueData === undefined ? null : JSON.parse(this.props.betSelection.Bets[0].OpaqueData);
            let ewValues = calculateEachWayValues(stake, this.props.betSelection.Bets[0].Market.Price, marketInfo.eachWayRatio);
            potentialReturns = getFormattedCurrency(this.props.store, ewValues.potentialReturns, 2);
            potentialReturns =  (potentialReturns && typeof potentialReturns === 'string' && potentialReturns.includes(String.fromCharCode(165))) ? potentialReturns.replace(String.fromCharCode(165), '') : potentialReturns;

            let combinedStake = parseFloat(this.props.betSelection.Bets[0].Stake);
            stake = getFormattedCurrency(this.props.store, roundNumber(combinedStake / BASE_VALUE, 2));

            if (this.props.betsType === SETTLED || this.props.betsType === SETTLED_IN_HISTORY) {
                prize = roundNumber(Number(this.props.betSelection.Bets[0].Prize) / BASE_VALUE, 2);
            }
        } else {
            let marketName = getRacingMarketNameByCode(marketInfo.marketCode) + (isMarbleEvent(this.props.betSelection.Bets[0].EventType) ? '_MARBLE' : '');
            betType = marketName === TO_WIN.name ? getText('WIN', this.props.store) : getText(marketName, this.props.store);
        }
        return (<LockedBet store={this.props.store} index={this.props.index} betSelection={this.props.betSelection}
                           names={racersNamesList} silks={silks} betType={betType} odd={odd} eventName={eventName}
                           isSettledBet={this.props.isSettledBet} potentialReturns={potentialReturns} stake={stake}
                           prize={prize} eventDetails={eventDetails} voidStatus={voidStatus}/>);
    }

    _getMarbleRacerNames(bet, racerNum, store) {

        let eventType = bet.EventType;
        let gameName = getGameByChannel(store, bet.Channel).name;
        let marbleRacerName = '';
        if (isMarbleEuroEvent(eventType, gameName)) {
            marbleRacerName = racerNum + '. ' + getText(gameName + "_" + racerNum, store);
        } else {
            marbleRacerName = getText('MARBLE', store) + ' ' + racerNum;
        }
        return marbleRacerName;
    }
}

export default connect(mapStateToProps)(LockedBetRacing);


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/racing/components/lockedBetRacing.js